var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.isDisplayed
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm.state == 1 ? _c('div', [_c('div', {
    staticClass: "mx-12 items-center w-auto h-auto rounded-lg p-5"
  }, [_c('h3', {
    staticClass: "w-full"
  }, [_vm._v("\n        Détacher " + _vm._s(_vm.neopassToDetach.firstname) + " "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.neopassToDetach.lastname))]), _vm._v(" de la structure\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "text-md text-indigo-600 font-normal text-center pt-8 pb-10"
  }, [[_vm.neopassToDetach.has_evaluation_perso_in_progress, _vm.neopassToDetach.has_evaluation_pro_in_progress, _vm.neopassToDetach.has_evaluation_socio_pro_in_progress].filter(function (v) {
    return v === true;
  }).length > 0 ? _c('div', {
    staticClass: "mb-5 text-pink-600"
  }, [_vm._v("\n          Des évaluations dans le"), [_vm.neopassToDetach.has_evaluation_perso_in_progress, _vm.neopassToDetach.has_evaluation_pro_in_progress, _vm.neopassToDetach.has_evaluation_socio_pro_in_progress].filter(function (v) {
    return v === true;
  }).length > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v("\n          module"), [_vm.neopassToDetach.has_evaluation_perso_in_progress, _vm.neopassToDetach.has_evaluation_pro_in_progress, _vm.neopassToDetach.has_evaluation_socio_pro_in_progress].filter(function (v) {
    return v === true;
  }).length > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v(" "), _vm.neopassToDetach.has_evaluation_perso_in_progress ? _c('span', [_vm._v("compétences personnelles")]) : _vm._e(), _vm._v(" "), _vm.neopassToDetach.has_evaluation_perso_in_progress && [_vm.neopassToDetach.has_evaluation_perso_in_progress, _vm.neopassToDetach.has_evaluation_pro_in_progress, _vm.neopassToDetach.has_evaluation_socio_pro_in_progress].filter(function (v) {
    return v === true;
  }).length === 2 ? _c('span', [_vm._v("\n            et\n          ")]) : _vm._e(), _vm._v(" "), _vm.neopassToDetach.has_evaluation_perso_in_progress && [_vm.neopassToDetach.has_evaluation_perso_in_progress, _vm.neopassToDetach.has_evaluation_pro_in_progress, _vm.neopassToDetach.has_evaluation_socio_pro_in_progress].filter(function (v) {
    return v === true;
  }).length === 3 ? _c('span', [_vm._v("\n            ,\n          ")]) : _vm._e(), _vm._v(" "), _vm.neopassToDetach.has_evaluation_socio_pro_in_progress ? _c('span', [_vm._v("compétences socio-professionnelles")]) : _vm._e(), _vm._v(" "), _vm.neopassToDetach.has_evaluation_pro_in_progress && _vm.neopassToDetach.has_evaluation_socio_pro_in_progress ? _c('span', [_vm._v("et")]) : _vm._e(), _vm._v(" "), _vm.neopassToDetach.has_evaluation_pro_in_progress ? _c('span', [_vm._v("compétences professionnelles")]) : _vm._e(), _vm._v(" sont en cours.\n          "), _c('p', [_vm._v("\n            En détachant ce Neopass de votre structure, ces évaluations en cours seront supprimées.\n          ")]), _vm._v(" "), _c('p', [_vm._v("\n            Seules les historiques seront conservés.\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "uppercase"
  }, [_vm._v("ê")]), _vm._v("tes vous sûr de vouloir détacher le Neopass de " + _vm._s(_vm.neopassToDetach.firstname) + " "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.neopassToDetach.lastname))]), _vm._v(" de votre structure ?\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('action-button', {
    staticClass: "p-3 font-normal",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('close');
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-5"
  }, [_c('action-button', {
    staticClass: "p-3 font-normal",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "CONFIRMER"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('confirmDetach');
      }
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), _vm.state == 2 ? _c('div', [_c('div', {
    staticClass: "mx-5 xl:mx-24 items-center w-auto h-auto rounded-lg p-5"
  }, [_c('h3', {
    staticClass: "w-full text-pink-600"
  }, [_vm._v("\n        Le Neopass de " + _vm._s(_vm.neopassToDetach.firstname) + " "), _c('span', {
    staticClass: "uppercase"
  }, [_vm._v(_vm._s(_vm.neopassToDetach.lastname))]), _vm._v(" a bien été détaché de la structure\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "w-full flex justify-center"
  }, [_c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1)])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }